import CityPageTemplate from "../city-template/CityPageTemplate";
import { martinsburgConfig } from "./data";

export default function MartinsburgPage() {
  return <CityPageTemplate config={martinsburgConfig} />;
}